<template>
  <button type="button" class="btn-link-neutral-s" @click="expanded = !expanded">
    {{ expanded ? lessLabel : moreLabel }}
    <ChevronUpIcon v-if="expanded" class="lucide-icon-s" />
    <ChevronDownIcon v-else class="lucide-icon-s" />
  </button>
</template>

<script setup lang="ts">
import { ChevronDownIcon, ChevronUpIcon } from '@ramp106/omrjs-core-ui/icons'

defineProps<{
  moreLabel: string
  lessLabel: string
}>()

const expanded = defineModel<boolean>('expanded', { required: true })
</script>
